import {AlternativePaymentMethodModel} from "../alternative-payment-method.model";
import {
    IRevolutPaymentMethodViewModel, IRevolutPointsConfiguration
} from "./revolut-payment-method.view-model.interface";
import {
    PaymentSupportedOS,
    PaymentSupportedPlatformTypes
} from "../../../../../configuration/objects/payments-configuration.interface";
import {PaymentMethodCategoryEnum} from "../payment-method-category.enum";
import RevolutCheckout from "@revolut/checkout";
import {RevolutPaymentControllerModel} from "./revolut-payment-controller.model";
import {IRevolutPaymentControllerViewModel, IRevolutPromotionalWidgetControllerViewModel} from "./revolut-payment-controller.view-model.interface";
import {RevolutPromotionalWidgetController} from "./revolut-promotional-widget.controller";
import React from "react";
import {
    RevolutPaymentMethodTabHeaderComponent
} from "../../../../../../pages/booking-flow/payment/revolut/revolut-payment-method-tab-header.component";
import {
    RevolutPaymentMethodTabContentComponent
} from "../../../../../../pages/booking-flow/payment/revolut/revolut-payment-method-tab-content.component";
import {RevolutButtonComponent} from "../../../../../../pages/booking-flow/payment/revolut/revolut-button.component";


export class RevolutPaymentMethodModel extends AlternativePaymentMethodModel implements IRevolutPaymentMethodViewModel {


    get name(): string {
        return "Revolut";
    }

    protected _getSupportedOS(): PaymentSupportedOS {
        return ['all'];
    }

    protected _getSupportedPlatformsTypes(): PaymentSupportedPlatformTypes {
        return ['all'];
    }

    protected async _canMakePayments(): Promise<boolean> {
        return Boolean(this.services.configuration.data.pspConfigs?.Revolut?.publicApiKey);
    }

    get category(): PaymentMethodCategoryEnum {
        return PaymentMethodCategoryEnum.AlternativePaymentMethod;
    }

    get revolutPointsConfiguration(): IRevolutPointsConfiguration {

        if(this._isX10RevPointsEnabled()) {
            return {
                marketingText: this.services.language.translate('Earn 10x RevPoints'),
                bannerImageUrl: this.services.theme.currentTheme.assets.images.payments.revolut_10x_points_banner_small_png.toString()
            }
        }


        return {
            marketingText: this.services.language.translate('Earn 2x RevPoints'),
            bannerImageUrl: this.services.theme.currentTheme.assets.images.payments.revolut_2x_points_banner_small_png.toString()
        }
    }

    private _isX10RevPointsEnabled(): boolean {

        const revPointsConfig = this.services.configuration.data.payments.revolut?.revPoints?.x10;
        if(!revPointsConfig) {
            return false;
        }

        const startDate = this.services.time.parseIsoDate(revPointsConfig.startDate);
        const endDate = this.services.time.parseIsoDate(revPointsConfig.endDate);
        const currentDate = this.services.time.currentDate;

        return currentDate >= startDate && currentDate <= endDate;

    }

    async createPaymentController(): Promise<IRevolutPaymentControllerViewModel> {
        const moduleInstance = await RevolutCheckout.payments({
            publicToken: this.services.configuration.data.pspConfigs.Revolut.publicApiKey,
            locale: (this.services.language.currentLanguageIso2 as any),
            mode: this.services.configuration.data.pspConfigs.Revolut.environment, // or 'prod' for production (default)
        });

        return new RevolutPaymentControllerModel(moduleInstance, this.code, this.booking);
    }

    async createPromotionalWidgetController(): Promise<IRevolutPromotionalWidgetControllerViewModel> {
        const moduleInstance = await RevolutCheckout.upsell({
            publicToken: this.services.configuration.data.pspConfigs.Revolut.publicApiKey,
            locale: (this.services.language.currentLanguageIso2 as any),
            mode: this.services.configuration.data.pspConfigs.Revolut.environment, // or 'prod' for production (default)
        });

        return new RevolutPromotionalWidgetController(moduleInstance, this.booking);
    }

    renderTabHeader(): React.ReactElement {
        return (
            <RevolutPaymentMethodTabHeaderComponent paymentMethod={this}/>
        );
    }

    renderTabContent(): React.ReactElement {
        return (
            <RevolutPaymentMethodTabContentComponent  revolutPaymentMethod={this} />
        );
    }

    renderPayButton(): React.ReactElement {
        return (
            <RevolutButtonComponent revolutPaymentMethod={this}/>
        );
    }


}